/**
 * Created by Karol Kluska on 26.09.17.
 */

angular
  .module('app')
  .component('guest', {
    templateUrl: 'app/components/guest/Guest.html',
    controller: Guest
  });

/** @ngInject */
// eslint-disable-next-line
function Guest($rootScope, Params, Restangular, OffersManager, OffersParser, $state, ENV, Currency, $translate, $uibModal, ConfigBookingEngine, ConfigHotel, AGE_CATEGORY, $window) {
  var $this = this;
  $this.$rootScope = $rootScope;
  $this.Params = Params;
  $this.Restangular = Restangular;
  $this.OffersParser = OffersParser;
  $this.OffersManager = angular.copy(OffersManager);
  $this.$state = $state;
  $this.ENV = ENV;
  $this.Currency = Currency;
  $this.$translate = $translate;
  $this.$uibModal = $uibModal;
  $this.ConfigBookingEngine = ConfigBookingEngine;
  $this.ConfigHotel = ConfigHotel;
  $this.ageCategories = ConfigBookingEngine.getAgeCategories();
  $this.AGE_CATEGORY = AGE_CATEGORY;
  $this.$window = $window;
  $this.isPanelEdited = false;
  $this.cart = [];
  $this.guest = {};
  $this.comments = '';
  $this.gatewayName = null;
  $this.validationFullNamePattern = '^[^\\s]{2,}\\s[^\\s]{1,}.*$';
  $this.validationEmailPattern = '(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$)';
  $this.validationPhonePattern = '^[0-9 \\(\\)+-]{4,20}$';
}

Guest.prototype = {
  $onInit: function () {
    this.userHash = this.Params.getUserHash();
    this.hotelId = this.Params.getHotelId();
    this.language = this.Params.getLanguage();
    this.checkIn = this.Params.getCheckIn();
    this.checkOut = this.Params.getCheckOut();
    this.occupancy = this.Params.getOccupancy();
    this.discountCode = this.Params.getDiscountCode();
    this.cart = this.Params.getCart() || [];
    var lengthOfStay = moment(this.checkOut).diff(this.checkIn, 'days');
    this.OffersManager.setLengthOfStay(lengthOfStay);
    this.OffersManager.setMinPersons(null);
    this.OffersManager.setRoomGroupId(null);
    this.OffersManager.setRateplanId(null);
    this.OffersManager.setOnlyAvailableRooms(true);
    this.OffersManager.setOnlyAvailableRateplans(true);
    this.getOffers();
    this.getPaymentMethods();
  },

  getOffers: function () {
    var $this = this;
    $this.$rootScope.$emit('startLoading', {
      title: this.$translate.instant('loader.PLEASE_WAIT'),
      description: this.$translate.instant('loader.AVAILABILITY')
    });
    /* eslint-disable camelcase */
    var requestParams = {
      start: moment($this.checkIn).format('YYYY-MM-DD'),
      end: moment($this.checkOut).subtract(1, 'day').format('YYYY-MM-DD'),
      hotel_id: this.hotelId,
      language: this.language,
      discount_code_name: this.discountCode
    };
    /* eslint-enable camelcase */
    $this.Restangular.all('preorders').customGET('shortstay/' + this.userHash + '?' + this.getItemsForApiGet(), requestParams)
      .then(function (preOrder) {
        $this.priceSummary = preOrder.summary;
        $this.fullOffersList = $this.OffersParser.parse(preOrder.offers);
        $this.filteredOffersList = $this.OffersManager.getAvailable($this.fullOffersList);
        $this.summary = $this.getSummary();
      })
      .catch(function () {
        $this.$state.go('booking.clientErrors', {}, {location: false});
      })
      .finally(function () {
        $this.$rootScope.$emit('stopLoading');
      });
  },

  isValidForm: function (form) {
    if (form.$valid) {
      return true;
    }

    angular.element('[name=\'' + form.$name + '\']').find('.ng-invalid:visible:first').focus();
    return false;
  },

  getPaymentMethods: function () {
    var $this = this;
    $this.Restangular.all('config-gateways/' + this.userHash).getList()
      .then(function (paymentMethods) {
        $this.paymentMethods = paymentMethods.sort(sortPaymentMethods);
        if (paymentMethods.length === 0) {
          /* eslint-disable camelcase */
          $this.paymentMethods = [{
            name: $this.$translate.instant('guest.payment_methods.DEFAULT_GATEWAY'),
            gateway_name: 'offline'
          }];
          /* eslint-enable camelcase */
        }
        if (paymentMethods.length === 1) {
          $this.gatewayName = $this.paymentMethods[0].gateway_name;
        }
      })
      .catch(function () {
        $this.$state.go('booking.clientErrors', {}, {location: false});
      });

    function sortPaymentMethods(a, b) {
      if (a.position < b.position) {
        return -1;
      }
      if (a.position > b.position) {
        return 1;
      }
      return 0;
    }
  },

  getSummary: function () {
    var result = {};
    result.items = [];
    for (var i = 0; i < this.cart.length; i++) {
      var cartItem = this.cart[i];
      var offer = this.searchItemInOffers(cartItem.roomId, cartItem.rateplanId, cartItem.persons);
      result.items.push(offer);
    }
    return this.isValidSummary(result) ? result : null;
  },

  isValidSummary: function (summary) {
    if (!angular.isArray(summary.items)) {
      return false;
    }

    if (summary.items.length === 0) {
      return false;
    }

    for (var i = 0; i < summary.items.length; i++) {
      var item = summary.items[i];
      if (item === null || angular.isUndefined(item)) {
        return false;
      }

      if (item.room === null || angular.isUndefined(item.room)) {
        return false;
      }

      if (item.rateplan === null || angular.isUndefined(item.rateplan)) {
        return false;
      }

      if (item.prices === null || angular.isUndefined(item.prices)) {
        return false;
      }
    }

    return true;
  },

  getTotalPrice: function () {
    if (angular.isDefined(this.priceSummary.discount_price) && this.priceSummary.discount_price !== null) {
      return this.Currency.getFormattedPrice(this.priceSummary.discount_price);
    }
    return this.Currency.getFormattedPrice(this.priceSummary.price);
  },

  getTotalCleaningPrice: function () {
    return this.Currency.getFormattedPrice(this.priceSummary.regular_fee);
  },

  hasCleaningPrice: function () {
    return this.priceSummary.regular_fee > 0;
  },

  hasRegulationsRodo: function () {
    if (this.ConfigBookingEngine.getRegulationsRodo() === null) {
      return false;
    }
    return true;
  },

  getAccommodationPrice: function () {
    if (angular.isDefined(this.priceSummary.discount_accommodation_price) && this.priceSummary.discount_accommodation_price !== null) {
      return this.Currency.getFormattedPrice(this.priceSummary.discount_accommodation_price);
    }
    return this.Currency.getFormattedPrice(this.priceSummary.accommodation_price);
  },

  getAdvancePrice: function () {
    return this.Currency.getFormattedPrice(this.priceSummary.advance);
  },

  getCompanyName: function () {
    return this.ConfigHotel.getCompanyName();
  },

  getGatewayImage: function (factoryName) {
    switch (factoryName) {
      case 'offline':
        return '/assets/img/payments/offline.jpg';
      case 'paypal_express_checkout':
        return '/assets/img/payments/paypal.png';
      case 'payu':
        return '/assets/img/payments/payu.jpg';
      case 'dotpay':
        return '/assets/img/payments/dotpay.jpg';
      case 'authorize_net_aim':
        return '/assets/img/payments/authorize-net.jpg';
      case 'payzen':
        return '/assets/img/payments/payzen.png';
      case 'eservice':
        return '/assets/img/payments/eservice.png';
      case 'payeezy':
        return '/assets/img/payments/payeezy.png';
      case 'espago':
        return '/assets/img/payments/espago.png';
      case 'przelewy24':
        return '/assets/img/payments/przelewy24.png';
      case 'tpay':
        return '/assets/img/payments/tpay.png';
      default:
        return '/assets/img/payments/offline.jpg';
    }
  },

  searchItemInOffers: function (roomId, rateplanId, personsCount) {
    var offer = this.filteredOffersList.filter(function (offer) {
      return offer.room.id === roomId;
    })[0];

    if (angular.isUndefined(offer)) {
      return null;
    }

    var rateplan = offer.rateplans.filter(function (rateplan) {
      return rateplan.id === rateplanId;
    })[0];

    if (angular.isUndefined(rateplan)) {
      return null;
    }

    var price = rateplan.prices.filter(function (price) {
      return price.personsCount === personsCount;
    })[0];

    if (angular.isUndefined(price)) {
      return null;
    }

    return {
      room: offer.room,
      rateplan: rateplan,
      prices: price
    };
  },

  openRegulations: function () {
    var $this = this;
    $this.$uibModal.open({
      component: 'modalSimple',
      size: 'lg',
      resolve: {
        title: function () {
          return $this.$translate.instant('guest.regulations.TITLE');
        },
        description: function () {
          return $this.ConfigBookingEngine.getRegulations();
        }
      }
    }).result.then(function () {}, function () {});
  },

  openRegulationsRodo: function () {
    var $this = this;
    $this.$uibModal.open({
      component: 'modalSimple',
      size: 'lg',
      resolve: {
        title: function () {
          return $this.$translate.instant('guest.regulations.TITLE_RODO');
        },
        description: function () {
          return $this.ConfigBookingEngine.getRegulationsRodo();
        }
      }
    }).result.then(function () {}, function () {});
  },

  getAgeCategoryTranslation: function (type) {
    var ageCategory = this.ageCategories.find(function (category) {
      return category.type === type;
    });
    return ageCategory.name;
  },

  getYear: function (date) {
    return moment(date).year();
  },

  getMonth: function (date) {
    var monthIndex = moment(date).month();
    var monthList = [
      this.$translate.instant('months_short.JAN'),
      this.$translate.instant('months_short.FEB'),
      this.$translate.instant('months_short.MAR'),
      this.$translate.instant('months_short.APR'),
      this.$translate.instant('months_short.MAY'),
      this.$translate.instant('months_short.JUN'),
      this.$translate.instant('months_short.JUL'),
      this.$translate.instant('months_short.AUG'),
      this.$translate.instant('months_short.SEP'),
      this.$translate.instant('months_short.OCT'),
      this.$translate.instant('months_short.NOV'),
      this.$translate.instant('months_short.DEC')
    ];
    return monthList[monthIndex];
  },

  getDayNumber: function (date) {
    var day = moment(date).date();
    return day < 10 ? '0' + day : day;
  },

  goToPreviousStep: function () {
    this.$state.go('booking.offers', {
      checkIn: moment(this.checkIn).format('YYYY-MM-DD'),
      checkOut: this.checkOut,
      occupancy: encodeURIComponent(angular.toJson(this.occupancy))
    });
  },

  getGuestDataForApi: function () {
    var guest = {
      country: 'PL',
      surname: this.guest.fullName,
      email: this.guest.email,
      phone: this.guest.phone,
      city: this.guest.city,
      street: this.guest.street,
      firm: false
    };

    if (this.showInvoiceForm) {
      guest.company = {
        surname: this.guest.companyName,
        nip: this.guest.companyVatId,
        city: this.guest.companyCity,
        street: this.guest.companyStreet
      };
    }
    return guest;
  },

  getItemsForApi: function () {
    var result = [];
    var items = this.cart;
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      /* eslint-disable camelcase */
      result.push({
        group_id: item.roomId,
        rateplan_id: item.rateplanId,
        persons_count: item.persons,
        age_category1: item.personsCat1,
        age_category2: item.personsCat2,
        age_category3: item.personsCat3
      });
      /* eslint-enable camelcase */
    }
    return result;
  },

  getItemsForApiGet: function () {
    var url = '';
    var items = this.cart;
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      url += 'items[' + i + '][group_id]=' + item.roomId +
        '&items[' + i + '][rateplan_id]=' + item.rateplanId +
        '&items[' + i + '][persons_count]=' + item.persons +
        '&items[' + i + '][age_category1]=' + item.personsCat1 +
        '&items[' + i + '][age_category2]=' + item.personsCat2 +
        '&items[' + i + '][age_category3]=' + item.personsCat3;
      if (i < items.length - 1) {
        url += '&';
      }
    }
    return url.trim();
  },

  goToNextStep: function () {
    var $this = this;
    var paymentTab;
    if ('parentIFrame' in window) {
      paymentTab = $this.$window.open($this.$state.href('booking.payment-redirect'), '_blank');
    }
    $this.$rootScope.$emit('startLoading', {
      title: $this.$translate.instant('loader.PLEASE_WAIT'),
      description: $this.$translate.instant('loader.SAVE_RESERVATION')
    });
    /* eslint-disable camelcase */
    var requestParams = {
      start: moment($this.checkIn).format('YYYY-MM-DD'),
      end: moment($this.checkOut).subtract(1, 'day').format('YYYY-MM-DD'),
      hotel_id: $this.hotelId,
      language: $this.language,
      currency: $this.Currency.getCurrency(),
      guest: $this.getGuestDataForApi(),
      comments: $this.comments,
      items: $this.getItemsForApi(),
      payment_gateway_name: $this.gatewayName,
      discount_code_name: $this.discountCode
    };
    /* eslint-enable camelcase */
    $this.Restangular.all('orders/shortstay/' + $this.userHash).post(requestParams)
      .then(function (response) {
        if (angular.isDefined(paymentTab)) {
          paymentTab.location = response.target_url;
          $this.$state.go('booking.payment-status', {
            token: response.after_url.substr(response.after_url.length - 43)
          });
        } else {
          $this.$window.open(response.target_url, '_self');
        }
      })
      .catch(function (error) {
        if (angular.isDefined(paymentTab)) {
          paymentTab.location = $this.$state.href('booking.clientErrors', {
            code: error.data.code
          }, {absolute: true});
        }
        $this.$state.go('booking.clientErrors', {
          code: error.data.code
        }, {location: false});
        $this.$rootScope.$emit('stopLoading');
      });
  }
};
